var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-result",
    {
      staticStyle: { "margin-top": "10%" },
      style: _vm.isLoading ? "display: none" : "",
      attrs: { subTitle: "您访问的资源不存在！" },
    },
    [
      _c(
        "template",
        { slot: "icon" },
        [
          _c("el-image", {
            staticStyle: { width: "50%" },
            attrs: { src: "image/error.png" },
          }),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }